module.exports = __webpack_public_path__ + "static/media/LA-PLAYER.21ab75f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/LA-PLAYER.png
// module id = 260
// module chunks = 0